import { createFileRoute } from '@tanstack/react-router';
import { LeaveTypesModule } from '@/modules/leave-type';

export const Route = createFileRoute('/(dashboard)/_dashboard/approval/leave-type')({
  component: LeaveTypesModule,
});
